// @flow

import { rem } from 'polished';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

import COLORS from 'client/constants/colors';
import SelectionListItem from 'client/components/list/selectionList/selectionListItem';
import Plus from 'client/components/plus';
import Translate from 'client/components/translate';

const getHealthProfileStyle = (isHealth: boolean) =>
  (isHealth
    ? `
      box-sizing: border-box;
      border: ${rem('1px')} solid ${COLORS.PRIMARY_700};
      border-radius: ${rem('4px')};
      background-color: ${COLORS.NEUTRAL_50};
      margin-bottom: ${rem('16px')};
      color: ${COLORS.PRIMARY_700};
    `
    : '');

const AddMemberButtonContainer = styled.div`
  a.selection-list-item {
    ${props => getHealthProfileStyle(props.isHealth)}
  }
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${COLORS.PRIMARY_700};
  font-weight: 700;
  margin: 0 0.25rem;
  padding: 0.25rem 0;
`;

type Props = {
  ariaLabel?: string | null,
  clickHandler: Function,
  disabled?: boolean,
  isHealth?: boolean,
  type: string,
};

class AddMemberButton extends PureComponent<Props> {
  static defaultProps = {
    ariaLabel: null,
    disabled: false,
    isHealth: false,
  };

  render() {
    const { ariaLabel, clickHandler, isHealth, type } = this.props;
    return (
      <AddMemberButtonContainer isHealth={isHealth}>
        <SelectionListItem
          checked={false}
          clickHandler={clickHandler}
          leftContent={
            <FlexContainer>
              <Plus ariaLabel={ariaLabel} />
              <Translate path={`common.member.add${type}`} className="accessible" />
            </FlexContainer>
          } />
      </AddMemberButtonContainer>
    );
  }
}

export default AddMemberButton;
